

















































































































import Vue, { PropType } from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';
import { IDataListAction, DataListsItem } from './types';

import { customizable } from '../../mixins/customizable';
import { Widthable } from '../../mixins/widthable';

import DataList from '../../elements/DataList';

import { mdiKeyboardBackspace } from '@mdi/js';

const Props = Vue.extend({
	props: {
		/** Hide the back button */
		hideBackBtn: {
			type: Boolean,
			default: false
		},
		/** Customize the text inside back button */
		backBtnText: {
			type: String,
			default: locales.backBtnText
		},
		/** Title of the SubHeader */
		titleText: {
			type: String,
			default: undefined
		},
		/** Sub-title of the SubHeader */
		subTitleText: {
			type: String,
			default: undefined
		},
		/** List of DataList components in column mode */
		dataLists: {
			type: Array as PropType<DataListsItem[]>,
			default: undefined
		},
		/** Loading mode */
		loading: {
			type: Boolean,
			default: false
		},
		/** Render the value as plain HTML */
		renderHtmlValue: {
			type: Boolean,
			default: false
		}
	}
});

const MixinsDeclaration = mixins(Props, customizable(config), Widthable);

/**
 * SubHeader is a component that displays
 * informations below the main header
 */
@Component({
	components: {
		DataList
	}
})
export default class SubHeader extends MixinsDeclaration {
	backArrowIcon = mdiKeyboardBackspace;

	/** Semi-transparent white */
	get fadeWhite(): string {
		return 'rgba(255, 255, 255, .7)';
	}

	/**
	 * Emit the dataList item object when user clicked on the corresponding action
	 *
	 * @param {number} dataListIndex The index of the selected data list
	 * @param {number} itemIndex The index of the item into the selected data list
	 */
	dataListItemAction(dataListIndex: number, itemIndex: number): void {
		this.$emit('click:list-item', { dataListIndex, itemIndex } as IDataListAction);
	}
}
